import { render, staticRenderFns } from "./FamiliareCard.vue?vue&type=template&id=714d7fcd&"
import script from "./FamiliareCard.vue?vue&type=script&lang=js&"
export * from "./FamiliareCard.vue?vue&type=script&lang=js&"
import style0 from "./FamiliareCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports